import { Component } from '../core/component.js';
import { DataModelBuilder, isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { PaymentType } from '../../models/serializable/payment-type.js';

export class ServicePaymentComponent extends Component {
  static readonly TYPE_ID: string = '2e7abf379977480590774e46179a80fc';

  constructor(
    public readonly paymentMethods: PaymentType[],
  ) {
    super();
  }

  get $typeId() {
    return ServicePaymentComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServicePaymentComponent {
    return new ServicePaymentComponent(
        MapUtils.getList<PaymentType>(
            map, 'paymentMethods',
            (value) => toEnumFromString(value as string, PaymentType, PaymentType.OnDelivery)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'paymentMethods': this.paymentMethods,
    };
  }

  clone(): this {
    return new ServicePaymentComponent(
        this.paymentMethods,
    ) as this;
  }

  isSame(other: ServicePaymentComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameList(other.paymentMethods, this.paymentMethods);
  }
}

export class ServicePaymentComponentBuilder extends DataModelBuilder<ServicePaymentComponent> {
  build(context: SerializationContext, map: SerializedData): ServicePaymentComponent {
    return ServicePaymentComponent.fromMap(context, map);
  }
}
